var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomFragments = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.375 10.391a2.35 2.35 0 0 1 1.875 2.296 2.35 2.35 0 0 1-1.875 2.297v3.797c0 .259-.21.469-.469.469h-3.75a.47.47 0 0 1-.469-.469c0-1.034-.84-1.875-1.874-1.875a1.877 1.877 0 0 0-1.876 1.875.47.47 0 0 1-.468.469h-3.75a.47.47 0 0 1-.469-.469v-3.75a.47.47 0 0 1 .469-.469 1.876 1.876 0 0 0 0-3.75.47.47 0 0 1-.469-.468v-3.75c0-.259.21-.469.469-.469h3.797a2.35 2.35 0 0 1 2.296-1.875c1.133 0 2.08.807 2.297 1.875h3.797c.26 0 .469.21.469.469zm-5.325 3.085a.89.89 0 0 0-.332-.7 2.7 2.7 0 0 0-1.693-.576 2.7 2.7 0 0 0-1.693.577.89.89 0 0 0-.332.7V14h4.05zm-2.025-1.726a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m3.15 0a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m1.693 1.027a2.7 2.7 0 0 0-1.693-.577c-.253 0-.478.034-.684.085.29.324.459.741.459 1.191V14h2.25v-.524a.89.89 0 0 0-.332-.7Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomFragments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/custom-fragments.d35af9e3.svg";